import { useState, useEffect, useRef } from "react";
import axios from 'axios'
import { globalPublicData } from "globalPublicData";
import { useSelector, useDispatch } from "react-redux";
// @mui material components
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import { useNavigate } from "react-router-dom";
import MDButton from "components/MDButton";
import { useCookies } from "react-cookie";
// import { defaultInputErrorState } from "./utils";
import validateEmptyString from "datavalidation/validateEmptyString";
import AMMDialog from "components/AMMDialog";
import SuccessDialog from "components/SuccessDialog";
import ErrorDialog from "components/ErrorDialog";


const EstatePGBuildingSubmitArea = (props) => {

    const navigate = useNavigate()
    const { 
        inputs, 
        editButton, 
        deleteButton, 
        submitCreateRequestButton, 
        approveButton, 
        assignBackButton,
        rejectButton,
        cancelButton, 
        updateTicketButton,
        setInputErrorState,
        ticket,
        createEndpoint,
        updateEndpoint,
        updateBatchTicketButton,
        deleteEndpoint,
        editRedirectUrl,
        defaultInputErrorState,
        file 
    } = props

    const user =  useSelector(state => state.user)
    const [cookies, setCookie, removeCookie] = useCookies()
    const axiosConfig = {
        headers: {
          Authorization: `Bearer ${user.token}`
        }
      }

    const axiosUploadConfig = {
        headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data"
        }
    }

    const [openDialog, setOpenDialog] = useState(false)
    const [openSuccessDialog, setOpenSuccessDialog] = useState(false)
    const [openErrorDialog, setOpenErrorDialog] = useState(false)

    const [dialogParams, setDialogParams] = useState({
        title: "Confirmation",
        messageLine1: "Are you sure you would like to proceed?",
        messageLine2: "Note: Please check all inputs before proceeding",
        handleSubmit: ()=>{}
    })

    const [successDialogParams, setSuccessDialogParams] = useState({ messageLine1: ""})
    const [errorDialogParams, setErrorDialogParams] = useState({ messageLine1: "", messageLine2: ""})

    const handleConfirmation = ( {title, messageLine1, messageLine2, handleSubmit} ) => {
        setDialogParams({
            // open: true,
            title: title,
            messageLine1: messageLine1,
            messageLine2: messageLine2,
            handleSubmit: handleSubmit
        })

        setOpenDialog(true)
    }

    const invalidInputsErrorHandler = () => {
        setErrorDialogParams({
            messageLine1: "Error: Please check your inputs and try again"
        })
        setOpenDialog(false)
        setOpenErrorDialog(true)
    }

    const generalErrorHandler = (messageLine1, messageLine2) => {
        setErrorDialogParams({
            messageLine1: messageLine1,
            messageLine2: messageLine2
        })
        setOpenDialog(false)
        setOpenErrorDialog(true)
    }


    const identifiedErrorHandler = (errData, handleSubmit)=>{
        setErrorDialogParams({
            messageLine1: "Apologies, an error has occured.",
            messageLine2: JSON.stringify(errData),
            handleSubmit: handleSubmit
        })
        setOpenErrorDialog(true)
    }

    const catchAllErrorHandler = () => {
        setErrorDialogParams({
            messageLine1: "Apologies, an error has occured.",
            messageLine2: "Please try again later."
        })
        setOpenDialog(false)
        setOpenErrorDialog(true)
    }

    const validateInputs = ()=>{
        
        var validationState = false
        var _inputErrorState = defaultInputErrorState
        Object.keys(defaultInputErrorState).map(item => {
            if (!validateEmptyString(inputs[item].toString())) {
                _inputErrorState[item] = {
                    state: true,
                    message: "Input must not be empty"
                }
            } else {
                _inputErrorState[item] = {
                    state: false,
                    message: ""
                }
            }
        })

        setInputErrorState({ ...defaultInputErrorState, _inputErrorState })
        
        var failedValidationArray = Object.entries(_inputErrorState).map(item => item[1].state)

        if (failedValidationArray.includes(true)) {
            console.log('[validateInputs] _inputErrorState: ', _inputErrorState)
            console.log('[validateInputs] dainputsta: ', inputs)
            validationState = false
        } else {
            validationState = true
        }

        return validationState
    }

    const handleSubmitCreateRequest = async () => {

        var dataToSend = {
            ...inputs
        }

        if (createEndpoint === "/propertygroup/create") {
            dataToSend.Gross_Floor_Area = Number(dataToSend.Gross_Floor_Area) || null 
        }

        if (createEndpoint === "/building/create") {
            dataToSend.Name = inputs.External_Facing_Name
            dataToSend.Gross_Floor_Area = Number(dataToSend.Gross_Floor_Area) || null 
            dataToSend.Longtitude = Number(dataToSend.Longtitude) || null 
            dataToSend.Latitude = Number(dataToSend.Latitude) || null 
            dataToSend.FEMS_Building_System_Code = Number(dataToSend.FEMS_Building_System_Code) || null 
            dataToSend.Postal_Code = Number(dataToSend.Postal_Code) || null 
            dataToSend.Number_Of_Floors = Number(dataToSend.Number_Of_Floors) || null 
            if (dataToSend.Estate_uuid) { delete dataToSend.Estate_uuid }
        }

        console.log("[handleSubmitCreateRequest] dataToSend is: ", dataToSend)
        
        const validationState = validateInputs()

        if (validationState){
        const endPoint = globalPublicData.baseEndpoint

        try {
            // const response = await axios.post(endPoint + "/estate/create", dataToSend, axiosConfig)
            const response = await axios.post(endPoint + createEndpoint, dataToSend, axiosConfig)
            console.log('post response is: ', response)
            if (response.status === 200) {
                setSuccessDialogParams({
                    messageLine1: "Create Request Ticket has been submitted for verification/approval",
                    handleSubmit: () => { navigate("/fb/app/home") }
                })
                setOpenDialog(false)
                setOpenSuccessDialog(true)
            }

        } catch (err) {
            console.log(err)
            if (err.response.data) {
                if (err.response.status === 410){
                    identifiedErrorHandler("A concurrent session was detected.", ()=>{navigate("/fb/app/")})
                } else if (err.response.status === 403){
                    navigate("/fb/app/403")
                } else if (err.response.status === 401){
                    navigate("/fb/app/401")
                } else {
                    identifiedErrorHandler(err.response.data, ()=>{})
                }
            } else {
                catchAllErrorHandler()
            }
        }

        } else {
            invalidInputsErrorHandler()
        }
    }

    const handleHODApproval = async () => {

        var dataToSend = {
            ...ticket,
            Object_Data: inputs
        }

        console.log('[handleSubmit] dataToSend are: ', dataToSend)
        const endPoint = globalPublicData.baseEndpoint
        try {
            const response = await axios.put(endPoint + "/ammticket/hod/approve", dataToSend, axiosConfig)
            console.log('[handleHODApproval] response is: ', response)
            if (response.status === 200) {
                setSuccessDialogParams({
                    messageLine1: "Ticket has been successfully approved",
                    handleSubmit: () => { navigate("/fb/app/home") }
                })
                setOpenDialog(false)
                setOpenSuccessDialog(true)
            }
        } catch (err) {
            console.log(err)
            if (err.response.data) {
                if (err.response.status === 410){
                    identifiedErrorHandler("A concurrent session was detected.", ()=>{navigate("/fb/app/")})
                } else if (err.response.status === 403){
                    navigate("/fb/app/403")
                } else if (err.response.status === 401){
                    navigate("/fb/app/401")
                } else {
                    identifiedErrorHandler(err.response.data, ()=>{})
                }
            } else {
                catchAllErrorHandler()
            }
        }
    }

    const handleUpdateTicket = async () => {
        const formData = new FormData()
        var dataToSend = {
            ...ticket,
            Object_Data: inputs
        }


        if (createEndpoint === "/propertygroup/create") {
            dataToSend.Object_Data.Gross_Floor_Area = Number(dataToSend.Object_Data.Gross_Floor_Area) || null 
        }

        if (createEndpoint === "/building/create") {
            dataToSend.Object_Data.Name = dataToSend.Object_Data.External_Facing_Name
            dataToSend.Object_Data.Gross_Floor_Area = Number(dataToSend.Object_Data.Gross_Floor_Area) || null 
            dataToSend.Object_Data.Longtitude = Number(dataToSend.Object_Data.Longtitude) || null 
            dataToSend.Object_Data.Latitude = Number(dataToSend.Object_Data.Latitude) || null 
            dataToSend.Object_Data.FEMS_Building_System_Code = Number(dataToSend.Object_Data.FEMS_Building_System_Code) || null 
            dataToSend.Object_Data.Number_Of_Floors = Number(dataToSend.Object_Data.Number_Of_Floors) || null 
            dataToSend.Object_Data.Postal_Code = Number(dataToSend.Object_Data.Postal_Code) || null 
            if (dataToSend.Object_Data.Estate_uuid) { delete dataToSend.Object_Data.Estate_uuid }
        }


        formData.append("data", JSON.stringify(dataToSend))

        const validationState = validateInputs()

        console.log('[handleUpdateTicket] dataToSend are: ', dataToSend)
        if (validationState){
        const endPoint = globalPublicData.baseEndpoint

        try {
            const response = await axios.put(endPoint + "/ammticket/update", formData, axiosConfig)
            console.log('[handleUpdateTicket] response is: ', response)
            if (response.status === 200) {
                setSuccessDialogParams({
                    messageLine1: "Ticket has been successfully re-submitted for verification/approval",
                    handleSubmit: () => { navigate("/fb/app/home") }
                })
                setOpenDialog(false)
                setOpenSuccessDialog(true)
            }

        } catch (err) {
            console.log(err)
            if (err.response.data) {
                if (err.response.status === 410){
                    identifiedErrorHandler("A concurrent session was detected.", ()=>{navigate("/fb/app/")})
                } else if (err.response.status === 403){
                    navigate("/fb/app/403")
                } else if (err.response.status === 401){
                    navigate("/fb/app/401")
                } else {
                    identifiedErrorHandler(err.response.data, ()=>{})
                }
            } else {
                catchAllErrorHandler()
            }
        }
    } else {
            invalidInputsErrorHandler()
    }
    }

    const handleUpdateBatchTicket = async () => {

        if (file){
            const formData = new FormData()
            formData.append(file.path, file)
            formData.append("data", JSON.stringify(ticket))
            try {
                const response = await axios.put(globalPublicData.baseEndpoint + "/ammticket/update", formData, axiosUploadConfig)
                console.log(response)
                if (response.status === 200) {
                    setSuccessDialogParams({
                        messageLine1: "Batch Upload Ticket has been re-submitted for verification/approval",
                        handleSubmit: () => { navigate("/fb/app/home") }
                    })
                    setOpenDialog(false)
                    setOpenSuccessDialog(true)
                }


            } catch (err) {
                console.log(err)
                if (err.response.data) {
                    if (err.response.status === 410){
                        identifiedErrorHandler("A concurrent session was detected.", ()=>{navigate("/fb/app/")})
                    } else if (err.response.status === 403){
                        navigate("/fb/app/403")
                    } else if (err.response.status === 401){
                        navigate("/fb/app/401")
                    } else {
                        identifiedErrorHandler(err.response.data, ()=>{})
                    }
                } else {
                    catchAllErrorHandler()
                }
            }
        } else {
            generalErrorHandler("Error: Please upload a file and try again.")
        }
    }

    const handleCancelTicket = async () => {

        if (user.email !== ticket.Requester_Email){
            return alert("Insufficient Account Priviledges: You can only reject tickets that you have raised.")
        }

        var dataToSend = {
            ...ticket,
            Object_Data: inputs
        }

        console.log('[handleSubmit] dataToSend are: ', dataToSend)

        const url = globalPublicData.baseEndpoint + "/ammticket/cancel"

        try {
            const response = await axios.put(url, dataToSend, axiosConfig)
            console.log('[handleCancelTicket] response is: ', response)
            if (response.status === 200) {
                setSuccessDialogParams({
                    messageLine1: "Ticket has been successfully cancelled",
                    handleSubmit: () => { navigate("/fb/app/home") }
                })
                setOpenDialog(false)
                setOpenSuccessDialog(true)
            }

        } catch (err) {
            console.log(err)
            if (err.response.data) {
                if (err.response.status === 410){
                    identifiedErrorHandler("A concurrent session was detected.", ()=>{navigate("/fb/app/")})
                } else if (err.response.status === 403){
                    navigate("/fb/app/403")
                } else if (err.response.status === 401){
                    navigate("/fb/app/401")
                } else {
                    identifiedErrorHandler(err.response.data, ()=>{})
                }
            } else {
                catchAllErrorHandler()
            }
        }
    }

    const handleRejectTicket = async () => {

        if (!user.roleClaims.includes("amm.hod")){
            return alert("Insufficient Account Priviledges: Only BSD HOD or BSD role(s) can reject tickets.")
        }
        var dataToSend = {
            ...ticket,
            Object_Data: inputs
        }

        console.log('[handleRejectTicket] dataToSend are: ', dataToSend)

        const url = globalPublicData.baseEndpoint + "/ammticket/reject"

        try {
            const response = await axios.put(url, dataToSend, axiosConfig)
            console.log('[handleRejectTicket] response is: ', response)
            if (response.status === 200) {
                setSuccessDialogParams({
                    messageLine1: "Ticket has been successfully rejected",
                    handleSubmit: () => { navigate("/fb/app/home") }
                })
                setOpenDialog(false)
                setOpenSuccessDialog(true)
            }

        } catch (err) {
            console.log(err)
            if (err.response.data) {
                if (err.response.status === 410){
                    identifiedErrorHandler("A concurrent session was detected.", ()=>{navigate("/fb/app/")})
                } else if (err.response.status === 403){
                    navigate("/fb/app/403")
                } else if (err.response.status === 401){
                    navigate("/fb/app/401")
                } else {
                    identifiedErrorHandler(err.response.data, ()=>{})
                }
            } else {
                catchAllErrorHandler()
            }
        }
    }

    const handleAssignBackTicket = async () => {

        if (!user.roleClaims.includes("amm.hod")){
            return alert("Insufficient Account Priviledges: Only BSD HOD or BSD role(s) can route back tickets.")
        }
        var dataToSend = {
            ...ticket,
            Object_Data: inputs
        }

        console.log('[handleAssignBackTicket] dataToSend are: ', dataToSend)

        const url = globalPublicData.baseEndpoint + "/ammticket/assignback"

        try {
            const response = await axios.put(url, dataToSend, axiosConfig)
            console.log('[handleAssignBackTicket] response is: ', response)
            if (response.status === 200) {
                setSuccessDialogParams({
                    messageLine1: "Ticket has been assigned back to Requester",
                    handleSubmit: ()=>{navigate("/fb/app/home")}
                })
                setOpenDialog(false)
                setOpenSuccessDialog(true)
            }

        } catch (err) {
            console.log(err)
            if (err.response.data) {
                if (err.response.status === 410){
                    identifiedErrorHandler("A concurrent session was detected.", ()=>{navigate("/fb/app/")})
                } else if (err.response.status === 403){
                    navigate("/fb/app/403")
                } else if (err.response.status === 401){
                    navigate("/fb/app/401")
                } else {
                    identifiedErrorHandler(err.response.data, ()=>{})
                }
            } else {
                catchAllErrorHandler()
            }
        }
    }


    const handleEdit = async () => {

        var dataToSend = {
            ...inputs,
        }

        if (updateEndpoint === "/building/update") { 
            if (dataToSend.Estate_uuid){delete dataToSend.Estate_uuid }
        }

        const validationState = validateInputs()

        console.log('[handleSubmit] dataToSend are: ', dataToSend)

        if (validationState){
        const endPoint = globalPublicData.baseEndpoint

            try {
                const response = await axios.put(endPoint + updateEndpoint, dataToSend, axiosConfig)
                console.log('put response is: ', response)
                if (response.status === 200) {
                    setSuccessDialogParams({
                        messageLine1: "Update Request Ticket has been submitted for verification/approval",
                        handleSubmit: () => { navigate("/fb/app/home") }
                    })
                    setOpenDialog(false)
                    setOpenSuccessDialog(true)
                }

            } catch (err) {
                console.log(err)
                if (err.response.data) {
                    if (err.response.status === 410){
                        identifiedErrorHandler("A concurrent session was detected.", ()=>{navigate("/fb/app/")})
                    } else if (err.response.status === 403){
                        navigate("/fb/app/403")
                    } else if (err.response.status === 401){
                        navigate("/fb/app/401")
                    } else {
                        identifiedErrorHandler(err.response.data, ()=>{})
                    }
                } else {
                    catchAllErrorHandler()
                }
            }
        } else {
            invalidInputsErrorHandler()
        }
    }

    const redirectToEdit = () => {
        navigate(editRedirectUrl, { state: inputs })
    }

    const handleDelete = async (id) => {

        const endPoint = globalPublicData.baseEndpoint
            + deleteEndpoint
            + "?id=" + id
            + "&modified_by=FrontendPlaceholder"

        try {
            console.log('[handleDelete] endpoint is: ', endPoint)
            const response = await axios.delete(endPoint, axiosConfig)

            console.log('delete response is: ', response)
            if (response.status === 200) {
                setSuccessDialogParams({
                    messageLine1: "Delete Request Ticket has been submitted for verification/approval",
                    handleSubmit: () => { navigate("/fb/app/home") }
                })
                setOpenDialog(false)
                setOpenSuccessDialog(true)
            }

        } catch (err) {
            console.log(err)
            if (err.response.data) {
                if (err.response.status === 410){
                    identifiedErrorHandler("A concurrent session was detected.", ()=>{navigate("/fb/app/")})
                } else if (err.response.status === 403){
                    navigate("/fb/app/403")
                } else if (err.response.status === 401){
                    navigate("/fb/app/401")
                } else {
                    identifiedErrorHandler(err.response.data, ()=>{})
                }
            } else {
                catchAllErrorHandler()
            }
        }
    }

    

    return (
        <>
                <Grid
                    container
                    alignItems="center"
                    justifyContent="flex-end"
                    spacing={3}
                    // mt={5}
                >
                    
                    {deleteButton.show ?
                    <Grid item xs={12} md={2}>
                            <MDButton
                                fullWidth
                                color={deleteButton.color || "error"}
                                // onClick={() => {handleDelete(inputs.id)}}
                                onClick={() => {
                                    handleConfirmation({
                                        title: "Delete Confirmation",
                                        messageLine1: "This action will proceed to submit the deletion ticket for verification/approval. Would you like to proceed?",
                                        messageLine2: "",
                                        handleSubmit: ()=>{handleDelete(inputs.id)}
                                    })
                                }}
                            >
                                {deleteButton.text}
                            </MDButton>
                        </Grid>
                    : null}
                    {editButton.show ?
                        <Grid item xs={12} md={2}>
                            <MDButton
                                fullWidth
                                color={editButton.color || "warning"}
                                onClick={editButton.redirectToEditPage ? 
                                    redirectToEdit : 
                                    ()=>{
                                        if (validateInputs()){
                                            handleConfirmation({
                                            title: "Edit Confirmation",
                                            messageLine1: "This action will proceed to submit the edit ticket for verification/approval. Would you like to proceed?",
                                            messageLine2: "",
                                            handleSubmit: handleEdit
                                            })
                                        } else {
                                            invalidInputsErrorHandler()
                                        }
                                
                                }}
                            >
                                {editButton.text}
                            </MDButton>    
                        </Grid>
                    : null}
                    {submitCreateRequestButton.show ? 
                        <Grid item xs={12} md={2}>
                            <MDButton
                                fullWidth
                                color={submitCreateRequestButton.color || "info"}
                                // onClick={handleSubmitCreateRequest}
                                onClick={() => {
                                    if (validateInputs()){ 
                                        handleConfirmation({
                                            title: "Create Ticket Confirmation",
                                            messageLine1: "This action will proceed to submit the creation ticket for verification/approval. Would you like to proceed?",
                                            messageLine2: "",
                                            handleSubmit: handleSubmitCreateRequest
                                        })
                                    } else {
                                        invalidInputsErrorHandler()
                                    }
                                }}
                            >
                                {submitCreateRequestButton.text}
                            </MDButton>
                        </Grid>
                    : null}
                    {cancelButton.show? 
                        <Grid item xs={12} md={2}>
                            <MDButton
                                fullWidth
                                color={cancelButton.color || "info"}
                                // onClick={handleCancelTicket}
                                onClick={() => {
                                    handleConfirmation({
                                        title: "Cancellation Confirmation",
                                        messageLine1: "This action will proceed to revoke & cancel the ticket. Would you like to proceed?",
                                        messageLine2: "",
                                        handleSubmit: handleCancelTicket
                                    })
                                }}
                            >
                                {cancelButton.text}
                            </MDButton>
                        </Grid>
                
                    : null}
                    {rejectButton.show? 
                        <Grid item xs={12} md={2}>
                            <MDButton
                                fullWidth
                                color={rejectButton.color || "info"}
                                // onClick={handleRejectTicket}
                                onClick={() => {
                                    handleConfirmation({
                                        title: "Rejection Confirmation",
                                        messageLine1: "This action will proceed to reject the ticket. Would you like to proceed?",
                                        messageLine2: "",
                                        handleSubmit: handleRejectTicket
                                    })
                                }}
                            >
                                {rejectButton.text}
                            </MDButton>
                        </Grid>
                
                    : null}
                    {assignBackButton.show? 
                        <Grid item xs={12} md={2}>
                            <MDButton
                                fullWidth
                                color={assignBackButton.color || "info"}
                                // onClick={handleAssignBackTicket}
                                onClick={()=>{handleConfirmation({
                                    title: "Reroute Confirmation",
                                    messageLine1: "Would you like to route this ticket back to " + ticket.Requester_Name +"?",
                                    messageLine2: "",
                                    handleSubmit: handleAssignBackTicket
                                })}}
                            >
                                {assignBackButton.text}
                            </MDButton>
                        </Grid>
                
                    : null}
                    {updateTicketButton.show ? 
                        <Grid item xs={12} md={2}>
                            <MDButton
                                fullWidth
                                color={updateTicketButton.color || "info"}
                                // onClick={handleUpdateTicket}
                                onClick={() => {
                                    if (validateInputs()){
                                        handleConfirmation({
                                            title: "Update Ticket Confirmation",
                                            messageLine1: "This action will resubmit the ticket for approval/verification. Would you like to proceed?",
                                            messageLine2: "",
                                            handleSubmit: handleUpdateTicket
                                        })
                                    } else {
                                        invalidInputsErrorHandler()
                                    }
                                }}
                            >
                                {updateTicketButton.text}
                            </MDButton>
                        </Grid>
                    : null}
                    {updateBatchTicketButton.show ?
                        <Grid item xs={12} md={2}>
                            <MDButton
                                fullWidth
                                color={updateTicketButton.color || "info"}
                                // onClick={handleUpdateTicket}
                                onClick={() => {
                                    handleConfirmation({
                                        title: "Update Ticket Confirmation",
                                        messageLine1: "This action will resubmit the ticket for approval/verification. Would you like to proceed?",
                                        messageLine2: "",
                                        handleSubmit: handleUpdateBatchTicket
                                    })

                                }}
                            >
                                {updateTicketButton.text}
                            </MDButton>
                        </Grid>
                        : null}
                    {approveButton.show ? 
                        <Grid item xs={12} md={2}>
                            <MDButton
                                fullWidth
                                color={approveButton.color || "info"}
                                // onClick={handleHODApproval}
                                onClick={() => {
                                    handleConfirmation({
                                        title: "Approval Confirmation",
                                        messageLine1: "This action will proceed to " + ticket.Ticket_Action_Type + " the " + ticket.Object_Type +". Would you like to proceed?",
                                        messageLine2: "",
                                        handleSubmit: handleHODApproval
                                    })
                                }}
                            >
                                {approveButton.text}
                            </MDButton>
                        </Grid>
                    : null}
                </Grid>
            <AMMDialog
                open={openDialog}
                title={dialogParams.title}
                messageLine1={dialogParams.messageLine1}
                messageLine2={dialogParams.messageLine2}
                handleSubmit={dialogParams.handleSubmit}    
                setOpenDialog={setOpenDialog}                
            />
            <SuccessDialog
                open={openSuccessDialog}
                messageLine1={successDialogParams.messageLine1}
                handleSubmit={successDialogParams.handleSubmit}
                setOpenDialog={setOpenSuccessDialog}                
            />
            <ErrorDialog
                open={openErrorDialog}
                messageLine1={errorDialogParams.messageLine1}
                messageLine2={errorDialogParams.messageLine2}
                setOpenDialog={setOpenErrorDialog}
            />
        </>
    )
}

export default EstatePGBuildingSubmitArea


EstatePGBuildingSubmitArea.defaultProps = {
    file: null,
    viewMode: false,
    disableIdField: false,
    title: "Building",
    editButton: {
        show: false,
        text: "Edit",
        color: "warning",
        redirectToEditPage: false
    },
    createButton: {
        show: false,
        text: "Create",
        color: "info"
    },
    deleteButton: {
        show: false,
        text: "Delete",
        color: "error"
    },
    submitCreateRequestButton: {
        show: false,
        text: "Submit Create Request",
        color: "info"
    },
    cancelButton: {
        show:false,
        text: "Cancel Request",
        color: "error"
    },
    assignBackButton: {
        show: false,
        text: "Route Back",
        color: "warning"
    },
    rejectButton: {
        show: false,
        text: "Reject Request",
        color: "error"
    },
    approveButton: {
        show: false,
        text: "Approve Request",
        color: "info"
    },
    updateTicketButton: {
        show: false,
        text: "Update Request",
        color: "info"
    }

};